import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { Col, Navbar, Row } from "@/utils/bootstrap";
import SvgClosePage from "./SvgClosePage";

interface Props {
  title: string;
  onClose: () => void;
}
const ModalAsPageHeader: React.FC<Props> = ({ title, onClose }) => {
  const company = useGetCompanyQuery();
  const navHeight = 58;

  return (
    <>
      <div style={{ marginTop: navHeight }} />
      <Navbar
        fixed="top"
        style={{
          height: navHeight,
          boxShadow: "0px 4px 16px rgba(4, 4, 4, 0.05)",
        }}
        className={`${
          company?.data?.result?.theme?.colors?.mobile_match_desktop_design &&
          "match-desktop"
        } mobile-header`}
      >
        <Row className="m-0 w-100">
          <Row xs={12} className="m-0 p-0 d-flex align-items-center">
            <Col className="p-0">
              <SvgClosePage onClick={onClose} />
            </Col>
            <Col className="p-0 text-nowrap" style={{ textAlign: "center" }}>
              {title}
            </Col>
            <Col className="p-0" />
          </Row>
        </Row>
      </Navbar>
    </>
  );
};

export default ModalAsPageHeader;
